import React, { useState } from "react";
import LogoBanner from "../../assets/images/LOGO CARIBBEAN HEALTH GROUP BANNER.svg";
import Circulos from "../../assets/images/Circulos.svg";
import bannerImage from "../../assets/images/pngwing 2.svg";
import line from "../../assets/images/Rectangle 533.svg";
import iconButton from "../../assets/icons/button.svg";
import "../../styles/divider.css";
import emailjs from "@emailjs/browser";
import Swal from "sweetalert2";
import { useTranslation } from "react-i18next";

function PrincipalBanner() {
  const [formContact, setFormContact] = useState({
    email: "",
    message: "",
    privacy: true,
  });
  const handleChange = () => {
    console.log("formContact.privacy:", formContact.privacy);
    setFormContact({
      ...formContact,
      privacy: !formContact.privacy,
    });
  };
  const sendEmail = (e) => {
    if (!formContact.privacy) {
      Swal.fire({
        title: "¡Atención!",
        text: "Es necesario aceptar la pólitica de privacidad y protección de datos personales.",
        icon: "warning",
        confirmButtonText: "Aceptar",
      });
    } else {
      if (!formContact.email ) {
        Swal.fire({
          title: "Datos incompletos",
          text: "Favor digitar correo electrónico",
          icon: "error",
          confirmButtonText: "Aceptar",
        });
      } else {
        e.preventDefault();
        emailjs
          .sendForm(
            "service_18djsgf",
            "template_2aji2gk",
            document.querySelector("#contactData"),
            "bCYLYypHI5fGgcDzL"
          )
          .then(
            (result) => {
              Swal.fire({
                title: "Tu correo ha sido enviado exitosamente",
                text: "Gracias por contactarte con Caribbean Health Group. Próximamente nos estaremos comunicando.",
                icon: "success",
                confirmButtonText: "Aceptar",
              });
              setFormContact({ email: "", message: "" });
            },
            (error) => {
              Swal.fire({
                title: "Error al enviar el correo",
                text: "Ocurrió un error al tratar de enviar el correo, por favor intente nuevamente.",
                icon: "error",
                confirmButtonText: "Aceptar",
              });
            }
          );
      }
    }
  };
  const { t } = useTranslation("common");
  return (
    <div id="home" className="flex flex-col w-full bg-principalBanner z-10">
      <div className="flex flex-col md:flex-row">
        <div className="flex flex-col justify-center items-center gap-2 flex-1">
          <div className="flex flex-col gap-2 items-center">
            {/* Logo en pantallas grandes */}
            <img
              src={LogoBanner}
              alt="Logo Banner"
              className="hidden md:block w-[25.5rem] "
            />
            {/* Logo para pantallas medianas */}
            <div className="flex lg:hidden flex-row justify-center  pt-6">
              <img
                src={LogoBanner}
                alt="Logo Banner"
                className="block md:hidden w-[60%] h-auto "
              />
            </div>
            <img src={line} alt="line" className="max-w-[90%] lg:w-[551px]" />
          </div>
          {/* texto informativo instituciones médicas */}
          <div className="flex max-w-[90%] flex-col justify-center  pl-0 w-[100%] lg:w-[80%] lg:pl-4 ">
            <p className="font-poppins  font-bold text-xl text-center text-white">
              {t("principal_banner.instituciones")}
            </p>
          </div>


          {/* FORMULARIO DE CONTACTO */}
          <div className="flex justify-center items-center pb-[12%] lg:pb-0">
            <div className="flex z-10 max-w-[90%] px-6 flex-col justify-start items-start rounded-[1.5rem] border-[2px] border-solid border-[#fff] textBoxPrincipalBanner ">
              <div className="flex flex-col justify-center items-center ">
                <div className="container">
                  <section className="">
                    <div className="">
                      <form
                        id="contactData"
                        onSubmit={sendEmail}
                        className="flex flex-col gap-3"
                      >
                        <div className="flex flex-row w-full pt-[0.6rem]">
                          <input
                            id="email"
                            type="email"
                            value={formContact.email}
                            onChange={(e) =>
                              setFormContact({
                                ...formContact,
                                email: e.target.value,
                              })
                            }
                            placeholder={t("contact.email")}
                            className="bg-transparent w-full text-white font-poppins text-[1rem] focus:border-[#fff] rounded-[1.5rem] border-[1px] border-solid border-[#fff]"
                          ></input>
                        </div>
                        {/* INICIO CAMPO SUBJECT */}
                        {/* <div className="flex flex-row">
                          <input
                            id="subject"
                            type="text"
                            placeholder={t("contact.subject")}
                            value={formContact.subject}
                            onChange={(e) =>
                              setFormContact({
                                ...formContact,
                                subject: e.target.value,
                              })
                            }
                            className="bg-transparent w-full text-white font-poppins text-[1rem]  focus:border-[#fff] rounded-[1.5rem] border-[1px] border-solid border-[#fff]"
                          ></input>
                        </div> */}
                        {/* FIN CAMPO SUBJECT */}
                        <div className="relative" data-te-input-wrapper-init>
                          <textarea
                            className="bg-transparent w-full text-white font-poppins text-[1rem]  focus:border-[#fff] rounded-[1.5rem] border-[1px] border-solid border-[#fff] [&:not([data-te-input-placeholder-active])]:placeholder:opacity-0"
                            id="message"
                            rows="2"
                            placeholder="Mensaje"
                            value={formContact.message}
                            onChange={(e) =>
                              setFormContact({
                                ...formContact,
                                message: e.target.value,
                              })
                            }
                          ></textarea>
                        </div>
                        <div className="inline-block min-h-[1.5rem] justify-center pl-[1.5rem] md:flex">
                          <input
                            className="relative float-left mt-[0.15rem] mr-[6px] -ml-[1.5rem] h-[1.125rem] w-[1.125rem] appearance-none rounded-[0.25rem] border-[0.125rem] border-solid border-neutral-300 outline-none before:pointer-events-none before:absolute before:h-[0.875rem] before:w-[0.875rem] before:scale-0 before:rounded-full before:bg-transparent before:opacity-0 before:shadow-[0px_0px_0px_13px_transparent] before:content-[''] checked:border-primary checked:bg-primary checked:before:opacity-[0.16] checked:after:absolute checked:after:ml-[0.25rem] checked:after:-mt-px checked:after:block checked:after:h-[0.8125rem] checked:after:w-[0.375rem] checked:after:rotate-45 checked:after:border-[0.125rem] checked:after:border-t-0 checked:after:border-l-0 checked:after:border-solid checked:after:border-white checked:after:bg-transparent checked:after:content-[''] hover:cursor-pointer hover:before:opacity-[0.04] hover:before:shadow-[0px_0px_0px_13px_rgba(0,0,0,0.6)] focus:shadow-none focus:transition-[border-color_0.2s] focus:before:scale-100 focus:before:opacity-[0.12] focus:before:shadow-[0px_0px_0px_13px_rgba(0,0,0,0.6)] focus:before:transition-[box-shadow_0.2s,transform_0.2s] focus:after:absolute focus:after:z-[1] focus:after:block focus:after:h-[0.875rem] focus:after:w-[0.875rem] focus:after:rounded-[0.125rem] focus:after:content-[''] checked:focus:before:scale-100 checked:focus:before:shadow-[0px_0px_0px_13px_#3b71ca] checked:focus:before:transition-[box-shadow_0.2s,transform_0.2s] checked:focus:after:ml-[0.25rem] checked:focus:after:-mt-px checked:focus:after:h-[0.8125rem] checked:focus:after:w-[0.375rem] checked:focus:after:rotate-45 checked:focus:after:rounded-none checked:focus:after:border-[0.125rem] checked:focus:after:border-t-0 checked:focus:after:border-l-0 checked:focus:after:border-solid checked:focus:after:border-white checked:focus:after:bg-transparent dark:border-neutral-600 dark:checked:border-primary dark:checked:bg-primary dark:focus:before:shadow-[0px_0px_0px_13px_rgba(255,255,255,0.4)] dark:checked:focus:before:shadow-[0px_0px_0px_13px_#3b71ca]"
                            type="checkbox"
                            checked={formContact.privacy}
                            id="privacy"
                            onChange={handleChange}
                          />
                          <label
                            className="inline-block pl-[0.15rem] text-[0.8rem] text-[#fff] font-poppins hover:cursor-pointer"
                            htmfor="privacy"
                          >
                            <a href="https://docs.google.com/uc?export=download&id=1pVjzvZFaSTRFbuDAAnSMMDQ0jobuPIy0">{t("contact.politics")}</a>
                          </label>
                        </div>
                        <div className="flex justify-center pb-2">
                          <div
                            onClick={sendEmail}
                            className="flex w-fit items-center px-3 bg-[#323A73] rounded-full  "
                          >
                            <p className="font-poppins text-[#fff]">
                              {t("contact.send")}
                            </p>
                            <img
                              src={iconButton}
                              alt="iconButton"
                              className="w-13 hover:cursor-pointer"
                            />
                          </div>
                        </div>
                      </form>
                    </div>
                  </section>
                </div>
              </div>
            </div>
          </div>
          {/* FORMULARIO DE CONTACTO */}



        </div>
        <div className="flex justify-center items-end">
          <img src={Circulos} alt="Cirulos" />
          <img className="absolute" src={bannerImage} alt="BannerImage" />
        </div>
      </div>
      <div className="flex relative">
        <div className="custom-shape-divider-bottom-1695183898 ">
          <svg
            data-name="Layer 1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 1200 120"
            preserveAspectRatio="none"
          >
            <path
              d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z"
              className="shape-fill"
            ></path>
          </svg>
        </div>
      </div>
    </div>
  );
}

export default PrincipalBanner;
